import logo from './logos/ooopener-yellow.svg'

export default logo ;
